import React, { useState } from "react";
import "./AddProducts.css";
import { useDispatch } from "react-redux";
import { addProductsData } from "../../features/addProducts/addProductsSlice";

const AddProducts = () => {
  const dispatch = useDispatch();
  const [productDetails, setproductDetails] = useState({
    title: "",
    coinValue: true,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title", productDetails.title);
    formData.append("coinValue", productDetails.coinValue);
    formData.append("file", productDetails?.file);

    dispatch(addProductsData(formData))
      .then((result) => {
        if (result?.payload?.response?.status === 404) {
          alert(result?.payload?.response?.data?.msg);
        } else if (result?.payload?.status === true) {
          window.location.href =
            "https://api.cricway.live/admin/all-reward-products";
          alert(result?.payload?.msg);
        }

        console.log("Form submitted successfully!", result);
        //  window.location.reload()
        // Handle the result as needed
      })
      .catch((error) => {
        console.error("Form submission failed:", error.message);
        // Handle the error as needed
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    // console.log(value);
    setproductDetails((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleFileChange = (e) => {
    // console.log(e.target)
    const image = e.target.files[0];
    setproductDetails((prevFormData) => ({
      ...prevFormData,
      file: image,
    }));
  };

  return (
    <div className="addProductWrapper">
      <div className="addProductContainer">
        <h2 className="formTitle">Add New Product </h2>
        <form
          className="addProductForm"
          onSubmit={handleSubmit}
          encType="multipart/form-data"
        >
          <label>
            Title:
            <input
              type="text"
              name="title"
              required
              value={productDetails.title}
              onChange={handleChange}
            />
          </label>
          <br />

          <label>
            Coin Value:
            <input
              type="number"
              name="coinValue"
              required
              value={productDetails.coinValue}
              onChange={handleChange}
            />
          </label>
          <br />
          <label className="fileUpload">
            Upload Files:
            <input
              type="file"
              name="files"
              required
              accept="image/png, image/jpeg, image/gif, image/tiff, image/psd,"
              onChange={handleFileChange}
            />
          </label>
          <br />

          <button type="submit" className="addProductButton">
            Add Product
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddProducts;
